import { post } from "../../../utils";
/**
 * FlowOperateReq
 */

export var apiTaskToOperate = function apiTaskToOperate(data) {
  return post({
    url: '/flow/core/toOperate',
    data: data,
    loading: true,
    errorTip: true
  });
};
/**
 * 处理页面详情
 *
 * FlowActionFormVo
 */

/**
 * ModifyFieldInfo
 */